<!-- Loader -->
<ng-container *ngIf="loading">
  Loading......
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</ng-container>
<!-- end of loader -->
<ng-container *ngIf="!loading">
  <mat-grid-list cols="6" rowHeight="550px">

    <mat-grid-tile colspan="2">
      <mat-card>
        <mat-card-content>
          <div>
            <form style="text-align: center;" [formGroup]="filterForm">
              <h4 id="filter">Select Parameters</h4>
              <br>
              <mat-form-field appearance="fill" style="float: left;">
                  <mat-label id="head">Parameter</mat-label>
                  <mat-select formControlName="parameter">
                      <mat-option *ngFor="let parameter of parameters" [value]="parameter">
                        {{parameter}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
              <br>
              <mat-form-field appearance="fill" style="float: left;">
                  <mat-label id="head">Enter a date range</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input formControlName="startDate" matStartDate placeholder="Start date">
                    <input formControlName="endDate" matEndDate placeholder="End date">
                  </mat-date-range-input>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <br><br>
                <!-- <mat-form-field appearance="fill" style="float: left;">
                  <mat-label id="head">Grade</mat-label>
                  <mat-input formControlName="grade" required>
                      
                  </mat-input>
              </mat-form-field> -->


              <mat-radio-group aria-label="Select an option" formControlName="iron1" required>
                  <mat-radio-button value="Grey Iron"><h3 id="head">Grey Iron</h3></mat-radio-button>&nbsp;
                  <mat-radio-button value="Ductile Iron"><h3 id="head">Ductile Iron</h3></mat-radio-button>
                </mat-radio-group>
                <br><br>
                <mat-radio-group aria-label="Select an option" formControlName="iron2" required>
                  <mat-radio-button value="Base Iron"><h3 id="head">Base Iron</h3></mat-radio-button>&nbsp;
                  <mat-radio-button value="Final Iron"><h3 id="head">Final Iron</h3></mat-radio-button>
                </mat-radio-group>
              <br>
              <mat-form-field appearance="fill" style="margin: 0 auto;">
                <mat-label >GRADE: </mat-label>
                <mat-select formControlName="grade" required>
                  <mat-option *ngFor="let type of drp_grade1" [value]="type">
                    {{ type }}
                     </mat-option>
                     </mat-select>
                  </mat-form-field>
<!--
              <label id="head">Grade : </label><br>
              <input formControlName="grade" placeholder="enter grade" required class="grade-entry">
              -->
              <br><br>
              <button type="button" class="btn btn-success" (click)="filter()">View</button>
              <button type="button" class="btn btn-warn" (click)="reset()">Reset</button>
            </form>
          </div>
        </mat-card-content>
      </mat-card>

    </mat-grid-tile>




    <mat-grid-tile id="graphtile" rowHeight="550px" colspan="4" *ngIf="data.length==0">
      <div class="alert alert-danger" role="alert">
        {{ alert }}
      </div>
    </mat-grid-tile>
    <mat-grid-tile id="graphtile" rowHeight="550px" colspan="4" *ngIf="data.length>0">
    <!-- <mat-grid-tile id="graphtile" rowHeight="550px" colspan="4" > -->
      <mat-card>
        <mat-card-content>
            <!-- <a href="#" (click)="downloadCanvas($event)" id="btn"> DOWNLOAD THIS</a> -->
            <!-- <div class="mychart" id='mychart'>
              <google-chart #chart (ready)="chartReady(chart)" id="chart"
                [title]="title"
                [type]="type"
                [data]="data"
                [columns]="columnNames"
                [options]="options"
                [width]="width"
                [height]="height"
                >
              </google-chart>
            </div> -->
            <div class="card">
              <p-chart type="line" width="700" height="400" [data]="basicData" [maintainAspectRatio]="false" />
            </div>
        </mat-card-content>
      </mat-card>
  </mat-grid-tile>


  
  </mat-grid-list>
  <!-- end of curve details -->
  <!-- curve defects -->
  <mat-grid-list id="bottom" cols="6" rowHeight="150px" style="padding-left: 4em; padding-right: 6em;">
      <div class="card" *ngIf="graphs.length>0">
          <div class="card-body">
            <table class="table table-hover">
              <thead class="text-primary">
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col" class="id">Curve ID</th>
                  <th scope="col">Class</th>
                  <th scope="col">Type</th>
                  <th scope="col">Grade</th>
                  <th scope="col">Heat Number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let curve of graphs">
                  <td>{{ transformDate(curve.createdAt) }}</td>
                  <td>{{ curve._id }}</td>
                  <td>{{ curve.iron1 }}</td>
                  <td>{{ curve.iron2 }}</td>
                  <td>{{ curve.grade }}</td>
                  <td>{{ curve.heatNumber }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  </mat-grid-list>
</ng-container>
